"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.estateReducer = void 0;
var EstateState_init_1 = require("@/pages/estate/states/EstateState.init");
var EstateAction_1 = require("@/pages/estate/actions/EstateAction");
var typesafe_actions_1 = require("typesafe-actions");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
exports.estateReducer = function (state, action) {
    if (state === void 0) { state = EstateState_init_1.defaultEstateState; }
    switch (action.type) {
        case typesafe_actions_1.getType(EstateAction_1.default.onSelectBlock): {
            var matchedIndex_1 = state.blocks.findIndex(function (it) { return it.location.lat === action.payload.location.lat && it.location.lng === action.payload.location.lng; });
            return __assign(__assign({}, state), { blocks: state.blocks.map(function (it, i) {
                    return i === matchedIndex_1 ? __assign(__assign({}, it), { active: true }) : __assign(__assign({}, it), { active: false });
                }) });
        }
        case typesafe_actions_1.getType(EstateAction_1.default.onLocationLabelClick): {
            return __assign(__assign({}, state), { phases: state.phases.map(function (it) {
                    return it.id === action.payload.phase.id ? __assign(__assign({}, it), { mapActive: true }) : __assign(__assign({}, it), { mapActive: false });
                }) });
        }
        case typesafe_actions_1.getType(EstateAction_1.default.setGalleryIndex): {
            return __assign(__assign({}, state), { galleryIndex: action.payload });
        }
        case typesafe_actions_1.getType(EstateAction_1.default.showPop): {
            return __assign(__assign({}, state), { galleryPop: action.payload });
        }
        case typesafe_actions_1.getType(EstateAction_1.default.setFullGalleryWidth): {
            return __assign(__assign({}, state), { galleryFullWidth: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setSort): {
            if (action.payload.filterType === SfilterTypeGroup_1.SfilterType.RENT) {
                return __assign(__assign({}, state), { availableRentSort: action.payload.field });
            }
            return __assign(__assign({}, state), { availableSaleSort: action.payload.field });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setOrder): {
            if (action.payload.filterType === SfilterTypeGroup_1.SfilterType.RENT) {
                return __assign(__assign({}, state), { availableRentOrder: action.payload.order });
            }
            return __assign(__assign({}, state), { availableSaleOrder: action.payload.order });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setAvailableItemIsSaved): {
            var newResultsRent = state.availablePropertiesRent
                ? (state.availablePropertiesRent.map(function (it) { return Number(it.referenceId) === Number(action.payload.id) ? (__assign(__assign({}, it), { isSaved: action.payload.state })) : it; }))
                : [];
            var newResultsSale = state.availablePropertiesSale
                ? (state.availablePropertiesSale.map(function (it) { return Number(it.referenceId) === Number(action.payload.id) ? (__assign(__assign({}, it), { isSaved: action.payload.state })) : it; }))
                : [];
            return __assign(__assign({}, state), { availablePropertiesRent: newResultsRent, availablePropertiesSale: newResultsSale });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setAvailableItemsIsSaved): {
            var ids_1 = action.payload.ids;
            var newResultsRent = state.availablePropertiesRent
                ? (state.availablePropertiesRent.map(function (it) { return ids_1.indexOf(Number(it.referenceId)) >= 0 ? (__assign(__assign({}, it), { isSaved: action.payload.state })) : it; }))
                : [];
            var newResultsSale = state.availablePropertiesSale
                ? (state.availablePropertiesSale.map(function (it) { return ids_1.indexOf(Number(it.referenceId)) >= 0 ? (__assign(__assign({}, it), { isSaved: action.payload.state })) : it; }))
                : [];
            return __assign(__assign({}, state), { availablePropertiesRent: newResultsRent, availablePropertiesSale: newResultsSale });
        }
        case typesafe_actions_1.getType(EstateAction_1.default.setSticky): {
            return __assign(__assign({}, state), { isSticky: action.payload });
        }
        case typesafe_actions_1.getType(EstateAction_1.default.setChartActiveIndex): {
            return __assign(__assign({}, state), { charts: state.charts.map(function (it, i) {
                    if (i === action.payload)
                        return __assign(__assign({}, it), { active: true });
                    return __assign(__assign({}, it), { active: false });
                }) });
        }
    }
    return state;
};
